module.exports = __webpack_public_path__ + "static/img/avatar-background.855d215.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar-background.png
// module id = vhKz
// module chunks = 1